//  Copyright (c) 2019 First Foundry Inc. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { withVenueID, withVenueSettings } from 'components/Venue'
import { Form } from 'react-final-form'
import Spinner from 'components/common/display/Spinner'
import ReportHeader from 'components/pages/reports/common/ReportHeader'
import { withQueryErrorPageOnError } from 'components/pages/ErrorPage'
import { renderWhileLoading } from 'utils/hoc'
import { compose } from 'recompose'
import { DEFAULT_TIMEZONE } from 'constants/Settings'
import { withState as withPackageLogsState } from 'store/modules/logs/packageLogs'
import PackageLogsTable from './PackageLogsTable'
import withPackageLogs from './withPackageLogs'

const PackageLogs = ({
  packageChangeLogData,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  venueSettings,
}) => (
  <Form
    initialValues={{
      startDate,
      endDate,
    }}
    onSubmit={(values) => {
      setStartDate(values.startDate)
      setEndDate(values.endDate)
    }}
    render={({ handleSubmit, values, form }) => {
      const leftArrowClick = (name) => {
        form.change(name, new Date(values[name].setDate(values[name].getDate() - 1)))
      }
      const rightArrowClick = (name) => {
        form.change(name, new Date(values[name].setDate(values[name].getDate() + 1)))
      }

      // group the data by date and employeeID
      const pkgLog = get(packageChangeLogData, 'node.changelog.edges')
      const pkgLogArray = []
      const pkgLogDates = []

      pkgLog.forEach((item) => {
        const logDate = item.node.timestamp.match(/(\d+-\d+-\d+T[0-1]?[0-9]|2[0-3]):[0-5][0-9]/)[0]
        pkgLogDates.push(logDate)
        if (pkgLogDates.indexOf(logDate) >= -1) {
          pkgLogDates.push(logDate)
        }
        pkgLogArray.push({
          id: item.node.id,
          employeeId: item.node.employeeId,
          employeeName: item.node.employeeName,
          logDate,
          timestamp: item.node.timestamp,
          payload: item.node.payload,
        })
      })
      // join related changes based on employeeID and Date
      const multipleGroupByArray = ((dataArray, groupPropertyArray) => {
        const groups = {}
        dataArray.forEach((item) => {
            const group = JSON.stringify(groupPropertyArray(item))
            groups[group] = groups[group] || []
            groups[group].push(item)
        })
        return Object.keys(groups).map(group => groups[group])
      })

      const groupedPkgLog = multipleGroupByArray(
        pkgLogArray, property => [property.logDate, property.employeeId],
      )
      const mappedPkgLog = []
      groupedPkgLog.forEach((item) => {
        const changes = []
        let employee = ''
        let empName = ''
        let logTime = ''
        item.forEach((logItem) => {
          employee = logItem.employeeId
          empName = logItem.employeeName
          logTime = logItem.timestamp
          changes.push(logItem.payload)
        })
        mappedPkgLog.push({
          employeeId: employee,
          employeeName: empName,
          timestamp: logTime,
          payload: changes,
        })
      })
      return (
        <form onSubmit={handleSubmit}>
          <ReportHeader
            startTime={startDate}
            endTime={endDate}
            leftArrowClick={leftArrowClick}
            rightArrowClick={rightArrowClick}
            onStartDateChange={selectedDate => form.change('startDate', new Date(selectedDate))}
            onEndDateChange={selectedDate => form.change('endDate', new Date(selectedDate))}
          />
          <PackageLogsTable
            storeTimezone={get(venueSettings, 'store.timezone', DEFAULT_TIMEZONE)}
            startDate={values.startDate}
            endDate={values.endDate}
            data={mappedPkgLog}
          />
        </form>
      )
    }}
  />
)

PackageLogs.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  packageChangeLogData: PropTypes.object,
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
  venueSettings: PropTypes.object,
}

export default compose(
  withPackageLogsState,
  withVenueID,
  withVenueSettings({ name: 'venueSettings' }),
  withPackageLogs,
  renderWhileLoading(
    () => <Spinner wrapStyle={{ paddingTop: '100px' }} />,
    ['packageChangeLogData'],
  ),
  withQueryErrorPageOnError(['packageChangeLogData'], true),
)(PackageLogs)
